module.exports = __webpack_public_path__ + "img/bluesky3100_04.f53e5ee2.jpg";